import React, { useEffect, useState } from "react";
import { ExternalLink, ChevronDown } from "lucide-react";
import { API_URL } from "../config";
import { useSpecialty } from "../SpecialtyContext";
import RatingWidget from "./RatingWidget";

function fmtDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("ru", { day: "numeric", month: "long", year: "numeric" });
  } catch { return ""; }
}

// «Не указано» и подобное в поле места — не место, не показываем
const hasPlace = loc => !!loc && !/не\s+указан/i.test(loc);

function startOfToday() {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
}

function EventCard({ ev, onLoginRequest, past }) {
  const CardTag = ev.source_url ? "a" : "div";
  const cardProps = ev.source_url
    ? { href: ev.source_url, target: "_blank", rel: "noopener noreferrer", style: { textDecoration: "none", color: "inherit", display: "block", cursor: "pointer" } }
    : {};
  return (
    <CardTag className="card" {...cardProps} style={{ ...(cardProps.style || {}), ...(past ? { opacity: 0.75 } : {}) }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8, flexWrap: "wrap" }}>
        <span style={{ fontSize: "0.88rem", color: "#888" }}>{fmtDate(ev.date)}</span>
        {hasPlace(ev.location) && <span style={{ marginLeft: "auto", fontSize: "0.88rem", color: "#555" }}>📍 {ev.location}</span>}
      </div>
      <div style={{ fontWeight: 700, fontSize: "1.08rem", color: "#007c84", marginBottom: 6, display: "flex", alignItems: "center", gap: 6 }}>
        {ev.title}
        {ev.source_url && <ExternalLink size={14} strokeWidth={2.2} style={{ flexShrink: 0, opacity: 0.6 }} />}
      </div>
      {ev.description && <div style={{ fontSize: "0.96rem", color: "#444" }}>{ev.description}</div>}
      <div style={{ marginTop: 8 }} onClick={e => e.preventDefault()}>
        <RatingWidget contentType="event" contentId={ev.id} onLoginRequest={onLoginRequest} compact />
      </div>
    </CardTag>
  );
}

export default function Events({ onLoginRequest }) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showPast, setShowPast] = useState(false);
  const { specialty } = useSpecialty();

  useEffect(() => {
    setLoading(true);
    const qs = specialty?.id ? `?specialty=${specialty.id}` : "";
    fetch(`${API_URL}/events${qs}`)
      .then(r => r.ok ? r.json() : [])
      .then(setEvents)
      .catch(() => setEvents([]))
      .finally(() => setLoading(false));
  }, [specialty]);

  // Предстоящие — ближайшие сверху; прошедшие — свежие сверху и свёрнуты
  const today = startOfToday();
  const isUpcoming = ev => !ev.date || new Date(ev.date) >= today;
  const upcoming = events.filter(isUpcoming).sort((a, b) => new Date(a.date || 0) - new Date(b.date || 0));
  const past = events.filter(ev => !isUpcoming(ev)).sort((a, b) => new Date(b.date) - new Date(a.date));
  const pastOpen = showPast || upcoming.length === 0;

  return (
    <section>
      <h1 className="section-title">Конференции и события</h1>

      {loading && <p style={{ color: "#888" }}>Загрузка…</p>}

      {!loading && events.length === 0 && (
        <p style={{ color: "#999", fontStyle: "italic" }}>Событий пока нет. Добавьте первое через CMS.</p>
      )}

      {!loading && events.length > 0 && upcoming.length === 0 && (
        <p style={{ color: "#999", fontStyle: "italic" }}>Предстоящих событий пока нет.</p>
      )}

      {upcoming.map(ev => <EventCard key={ev.id} ev={ev} onLoginRequest={onLoginRequest} />)}

      {past.length > 0 && (
        <>
          {upcoming.length > 0 && (
            <button type="button" className="events-past-toggle" aria-expanded={pastOpen} onClick={() => setShowPast(v => !v)}>
              Прошедшие события ({past.length})
              <ChevronDown size={16} strokeWidth={2.2} style={{ transform: pastOpen ? "rotate(180deg)" : "none", transition: "transform 0.2s" }} />
            </button>
          )}
          {pastOpen && past.map(ev => <EventCard key={ev.id} ev={ev} onLoginRequest={onLoginRequest} past />)}
        </>
      )}
    </section>
  );
}
